<template>
  <section class="layout-section -bg-primary">
    <div class="layout-section__hgroup -bigger">
      <h2 class="layout-section__title">Contenu dépliable</h2>
      <p>
        Ce type de mise en page permet de présenter de grandes quantités de contenu sans surcharger visuellement
        l’interface. L’utilisateur peut déplier uniquement les sections qui l’intéressent, favorisant ainsi une
        navigation plus fluide.
      </p>
    </div>

    <DemoDropdownBox
      v-for="({ content, ...dropdown }, i) in dropdowns"
      :key="i"
      v-bind="dropdown"
      @close="dropdowns[i].isOpen = false"
      @open="onOpenDropdown(i)"
    >
      <p v-for="p in content" :key="p">{{ p }}</p>
    </DemoDropdownBox>
  </section>
</template>

<script>
import DemoDropdownBox from './DemoDropdownBox.vue'

export default {
  name: 'ComponentDemoDropdown',
  components: { DemoDropdownBox },
  data() {
    return {
      dropdowns: [
        {
          title: 'Simple Dropdown',
          isOpen: false,
          content: [
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum error cupiditate adipisci voluptas ad ratione sed dicta voluptate architecto. Eum, ducimus ipsa. Inventore nam fugit harum eum doloribus, modi impedit.'
          ]
        },
        {
          title: 'Dropdown with multiple paragraph',
          isOpen: false,
          content: [
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum error cupiditate adipisci voluptas ad ratione sed dicta voluptate architecto.',
            'Eum, ducimus ipsa. Inventore nam fugit harum eum doloribus, modi impedit. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum error cupiditate adipisci voluptas ad ratione sed dicta voluptate architecto. Eum, ducimus ipsa. Inventore nam fugit harum eum doloribus, modi impedit.'
          ]
        }
      ]
    }
  },
  methods: {
    onOpenDropdown(index) {
      this.dropdowns.forEach(dropdown => {
        dropdown.isOpen = false
      })
      this.dropdowns[index].isOpen = true
    }
  }
}
</script>
